import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { UserMessageContext } from './UserMessage';
import { lineThrough, link } from '../../../../../utils/styles';

const StyledLink = styled.span`
  ${link};
  user-select: none;

  ${props =>
    props.active &&
    css`
      ${lineThrough(props.theme.colorMinor)};
    `};

  ${props =>
    props.disabled &&
    css`
      cursor: default;
      pointer-events: none;
    `};
`;

const InputLink = ({ name, ...rest }) => (
  <UserMessageContext.Consumer>
    {({ onLinkClick, activeName, disabled }) => (
      <StyledLink
        {...rest}
        onClick={() => onLinkClick(name)}
        answered={!!activeName}
        active={name === activeName}
        disabled={disabled}
      >
        {name}
      </StyledLink>
    )}
  </UserMessageContext.Consumer>
);

InputLink.propTypes = {
  name: PropTypes.string.isRequired,
};

export default InputLink;



// WEBPACK FOOTER //
// ./src/scenes/Brief/components/BriefBot/components/InputLink.js